module.exports = __webpack_public_path__ + "static/media/linkedin_logo.8d61da74.png";